"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _constants = require("@seedlang/constants");
var _hoc = require("@seedlang/hoc");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _mobxReact = require("mobx-react");
var _react = _interopRequireDefault(require("react"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _ai_icon = _interopRequireDefault(require("./ai_icon"));
var _flag_ab_icon = _interopRequireDefault(require("./flag_ab_icon"));
var _flag_af_icon = _interopRequireDefault(require("./flag_af_icon"));
var _flag_ar_icon = _interopRequireDefault(require("./flag_ar_icon"));
var _flag_aus_icon = _interopRequireDefault(require("./flag_aus_icon"));
var _flag_az_icon = _interopRequireDefault(require("./flag_az_icon"));
var _flag_bg_icon = _interopRequireDefault(require("./flag_bg_icon"));
var _flag_bn_icon = _interopRequireDefault(require("./flag_bn_icon"));
var _flag_br_icon = _interopRequireDefault(require("./flag_br_icon"));
var _flag_brazil_icon = _interopRequireDefault(require("./flag_brazil_icon"));
var _flag_bs_icon = _interopRequireDefault(require("./flag_bs_icon"));
var _flag_ca_icon = _interopRequireDefault(require("./flag_ca_icon"));
var _flag_can_icon = _interopRequireDefault(require("./flag_can_icon"));
var _flag_cn_icon = _interopRequireDefault(require("./flag_cn_icon"));
var _flag_cs_icon = _interopRequireDefault(require("./flag_cs_icon"));
var _flag_da_icon = _interopRequireDefault(require("./flag_da_icon"));
var _flag_de_icon = _interopRequireDefault(require("./flag_de_icon"));
var _flag_el_icon = _interopRequireDefault(require("./flag_el_icon"));
var _flag_en_icon = _interopRequireDefault(require("./flag_en_icon"));
var _flag_eo_icon = _interopRequireDefault(require("./flag_eo_icon"));
var _flag_es_icon = _interopRequireDefault(require("./flag_es_icon"));
var _flag_et_icon = _interopRequireDefault(require("./flag_et_icon"));
var _flag_eu_icon = _interopRequireDefault(require("./flag_eu_icon"));
var _flag_fa_icon = _interopRequireDefault(require("./flag_fa_icon"));
var _flag_fi_icon = _interopRequireDefault(require("./flag_fi_icon"));
var _flag_fj_icon = _interopRequireDefault(require("./flag_fj_icon"));
var _flag_fo_icon = _interopRequireDefault(require("./flag_fo_icon"));
var _flag_fr_icon = _interopRequireDefault(require("./flag_fr_icon"));
var _flag_gd_icon = _interopRequireDefault(require("./flag_gd_icon"));
var _flag_gl_icon = _interopRequireDefault(require("./flag_gl_icon"));
var _flag_ha_icon = _interopRequireDefault(require("./flag_ha_icon"));
var _flag_hi_icon = _interopRequireDefault(require("./flag_hi_icon"));
var _flag_hr_icon = _interopRequireDefault(require("./flag_hr_icon"));
var _flag_hu_icon = _interopRequireDefault(require("./flag_hu_icon"));
var _flag_hy_icon = _interopRequireDefault(require("./flag_hy_icon"));
var _flag_in_icon = _interopRequireDefault(require("./flag_in_icon"));
var _flag_irl_icon = _interopRequireDefault(require("./flag_irl_icon"));
var _flag_it_icon = _interopRequireDefault(require("./flag_it_icon"));
var _flag_iw_icon = _interopRequireDefault(require("./flag_iw_icon"));
var _flag_ja_icon = _interopRequireDefault(require("./flag_ja_icon"));
var _flag_ka_icon = _interopRequireDefault(require("./flag_ka_icon"));
var _flag_kk_icon = _interopRequireDefault(require("./flag_kk_icon"));
var _flag_ko_icon = _interopRequireDefault(require("./flag_ko_icon"));
var _flag_ku_icon = _interopRequireDefault(require("./flag_ku_icon"));
var _flag_la_icon = _interopRequireDefault(require("./flag_la_icon"));
var _flag_lt_icon = _interopRequireDefault(require("./flag_lt_icon"));
var _flag_lv_icon = _interopRequireDefault(require("./flag_lv_icon"));
var _flag_mk_icon = _interopRequireDefault(require("./flag_mk_icon"));
var _flag_ml_icon = _interopRequireDefault(require("./flag_ml_icon"));
var _flag_mn_icon = _interopRequireDefault(require("./flag_mn_icon"));
var _flag_mr_icon = _interopRequireDefault(require("./flag_mr_icon"));
var _flag_ms_icon = _interopRequireDefault(require("./flag_ms_icon"));
var _flag_my_icon = _interopRequireDefault(require("./flag_my_icon"));
var _flag_ne_icon = _interopRequireDefault(require("./flag_ne_icon"));
var _flag_nl_icon = _interopRequireDefault(require("./flag_nl_icon"));
var _flag_no_icon = _interopRequireDefault(require("./flag_no_icon"));
var _flag_nzl_icon = _interopRequireDefault(require("./flag_nzl_icon"));
var _flag_or_icon = _interopRequireDefault(require("./flag_or_icon"));
var _flag_pa_icon = _interopRequireDefault(require("./flag_pa_icon"));
var _flag_pl_icon = _interopRequireDefault(require("./flag_pl_icon"));
var _flag_ps_icon = _interopRequireDefault(require("./flag_ps_icon"));
var _flag_pt_icon = _interopRequireDefault(require("./flag_pt_icon"));
var _flag_ro_icon = _interopRequireDefault(require("./flag_ro_icon"));
var _flag_ru_icon = _interopRequireDefault(require("./flag_ru_icon"));
var _flag_rw_icon = _interopRequireDefault(require("./flag_rw_icon"));
var _flag_sh_icon = _interopRequireDefault(require("./flag_sh_icon"));
var _flag_si_icon = _interopRequireDefault(require("./flag_si_icon"));
var _flag_sk_icon = _interopRequireDefault(require("./flag_sk_icon"));
var _flag_sl_icon = _interopRequireDefault(require("./flag_sl_icon"));
var _flag_sm_icon = _interopRequireDefault(require("./flag_sm_icon"));
var _flag_sq_icon = _interopRequireDefault(require("./flag_sq_icon"));
var _flag_sr_icon = _interopRequireDefault(require("./flag_sr_icon"));
var _flag_sv_icon = _interopRequireDefault(require("./flag_sv_icon"));
var _flag_sw_icon = _interopRequireDefault(require("./flag_sw_icon"));
var _flag_ta_icon = _interopRequireDefault(require("./flag_ta_icon"));
var _flag_taiwan_icon = _interopRequireDefault(require("./flag_taiwan_icon"));
var _flag_te_icon = _interopRequireDefault(require("./flag_te_icon"));
var _flag_tg_icon = _interopRequireDefault(require("./flag_tg_icon"));
var _flag_th_icon = _interopRequireDefault(require("./flag_th_icon"));
var _flag_tk_icon = _interopRequireDefault(require("./flag_tk_icon"));
var _flag_tl_icon = _interopRequireDefault(require("./flag_tl_icon"));
var _flag_tr_icon = _interopRequireDefault(require("./flag_tr_icon"));
var _flag_uk_icon = _interopRequireDefault(require("./flag_uk_icon"));
var _flag_ur_icon = _interopRequireDefault(require("./flag_ur_icon"));
var _flag_us_icon = _interopRequireDefault(require("./flag_us_icon"));
var _flag_vi_icon = _interopRequireDefault(require("./flag_vi_icon"));
var _flag_wo_icon = _interopRequireDefault(require("./flag_wo_icon"));
var _flag_yo_icon = _interopRequireDefault(require("./flag_yo_icon"));
var _flag_zh_icon = _interopRequireDefault(require("./flag_zh_icon"));
var _templateObject, _templateObject2, _class, _LanguageIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var COMPONENTS = {
  EN: _flag_us_icon["default"],
  EN2: _flag_en_icon["default"],
  FR: _flag_fr_icon["default"],
  FA: _flag_fa_icon["default"],
  RO: _flag_ro_icon["default"],
  ES: _flag_es_icon["default"],
  KO: _flag_ko_icon["default"],
  HR: _flag_hr_icon["default"],
  UK: _flag_uk_icon["default"],
  EL: _flag_el_icon["default"],
  PT: _flag_pt_icon["default"],
  PT2: _flag_brazil_icon["default"],
  DE: _flag_de_icon["default"],
  RU: _flag_ru_icon["default"],
  SQ: _flag_sq_icon["default"],
  IT: _flag_it_icon["default"],
  HU: _flag_hu_icon["default"],
  TR: _flag_tr_icon["default"],
  ZH: _flag_zh_icon["default"],
  ZH2: _flag_taiwan_icon["default"],
  VI: _flag_vi_icon["default"],
  PL: _flag_pl_icon["default"],
  SR: _flag_sr_icon["default"],
  SV: _flag_sv_icon["default"],
  CS: _flag_cs_icon["default"],
  SH: _flag_sh_icon["default"],
  AR: _flag_ar_icon["default"],
  JA: _flag_ja_icon["default"],
  IN: _flag_in_icon["default"],
  NL: _flag_nl_icon["default"],
  BG: _flag_bg_icon["default"],
  SK: _flag_sk_icon["default"],
  KA: _flag_ka_icon["default"],
  LT: _flag_lt_icon["default"],
  SL: _flag_sl_icon["default"],
  HY: _flag_hy_icon["default"],
  CN: _flag_cn_icon["default"],
  AZ: _flag_az_icon["default"],
  FI: _flag_fi_icon["default"],
  BN: _flag_bn_icon["default"],
  TH: _flag_th_icon["default"],
  EU: _flag_eu_icon["default"],
  MK: _flag_mk_icon["default"],
  NO: _flag_no_icon["default"],
  LV: _flag_lv_icon["default"],
  NE: _flag_ne_icon["default"],
  AF: _flag_af_icon["default"],
  ET: _flag_et_icon["default"],
  TL: _flag_tl_icon["default"],
  HI: _flag_hi_icon["default"],
  BS: _flag_bs_icon["default"],
  DA: _flag_da_icon["default"],
  IW: _flag_iw_icon["default"],
  MY: _flag_my_icon["default"],
  MN: _flag_mn_icon["default"],
  EO: _flag_eo_icon["default"],
  KK: _flag_kk_icon["default"],
  MS: _flag_ms_icon["default"],
  CA: _flag_ca_icon["default"],
  ML: _flag_ml_icon["default"],
  SI: _flag_si_icon["default"],
  TA: _flag_ta_icon["default"],
  PS: _flag_ps_icon["default"],
  MR: _flag_mr_icon["default"],
  FO: _flag_fo_icon["default"],
  KU: _flag_ku_icon["default"],
  LA: _flag_la_icon["default"],
  SW: _flag_sw_icon["default"],
  TE: _flag_te_icon["default"],
  GL: _flag_gl_icon["default"],
  KN: _flag_hi_icon["default"],
  FJ: _flag_fj_icon["default"],
  UR: _flag_ur_icon["default"],
  SM: _flag_sm_icon["default"],
  HA: _flag_ha_icon["default"],
  BR: _flag_br_icon["default"],
  PA: _flag_pa_icon["default"],
  TG: _flag_tg_icon["default"],
  YO: _flag_yo_icon["default"],
  AB: _flag_ab_icon["default"],
  WO: _flag_wo_icon["default"],
  RW: _flag_rw_icon["default"],
  OR: _flag_or_icon["default"],
  TK: _flag_tk_icon["default"],
  GD: _flag_gd_icon["default"],
  AI: _ai_icon["default"],
  GBR: _flag_en_icon["default"],
  USA: _flag_us_icon["default"],
  CAN: _flag_can_icon["default"],
  NZL: _flag_nzl_icon["default"],
  AUS: _flag_aus_icon["default"],
  IRL: _flag_irl_icon["default"]
};
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: ", ";\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return props.margin;
}, function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var AbbreviationIcon = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  border-radius: 50%;\n  background: white;\n  border: 2px solid #333;\n  font-weight: bold;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.fontSize;
});
var LanguageIcon = (0, _mobxReact.observer)(_class = (_LanguageIcon = /*#__PURE__*/function (_React$Component) {
  function LanguageIcon(props) {
    var _this;
    _classCallCheck(this, LanguageIcon);
    _this = _callSuper(this, LanguageIcon, [props]);
    _this.id = (0, _utils.createUuid)();
    return _this;
  }
  _inherits(LanguageIcon, _React$Component);
  return _createClass(LanguageIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        margin: this.props.margin,
        width: (0, _utils.pixify)(this.props.width)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-tip": this.props.showTooltip,
        "data-for": this.id
      }, (0, _lodash.keys)(COMPONENTS).includes(this.props.flagId) && /*#__PURE__*/_react["default"].createElement(COMPONENTS[this.props.flagId], {
        width: (0, _utils.pixify)(this.props.width)
      }), !(0, _lodash.keys)(COMPONENTS).includes(this.props.flagId) && /*#__PURE__*/_react["default"].createElement(AbbreviationIcon, {
        width: (0, _utils.pixify)(this.props.width),
        fontSize: (0, _utils.pixify)(this.props.fontSize)
      }, this.props.flagId), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
        place: "top",
        type: "dark",
        effect: "solid",
        id: this.id,
        "class": "custom-tooltip"
      }, _constants.Languages[this.props.flagId])));
    }
  }]);
}(_react["default"].Component), _LanguageIcon.defaultProps = {
  width: 20,
  fontSize: 8
}, _LanguageIcon)) || _class;
var _default = exports["default"] = (0, _hoc.LanguageIconWrapper)(LanguageIcon);